import { NavItemType } from 'types';
import { IconApps } from '@tabler/icons-react';

// ==============================|| MENU ITEMS - APPLICATION ||============================== //

const application: NavItemType = {
  id: 'application',
  title: 'application',
  icon: IconApps,
  type: 'group',
  children: []
};

export default application;
